import * as actionTypes from './actionTypes';
import { I_Itineraries } from './interfaces';

const initialState = {
    // TourID: null,
    // GroupID: null,
    // NormGroupID: "",
    // IsPreview: false,
    // TravelType: null,
    // TourName: "",
    // ArriveID: "",
    Features: '',
    UpDateTime: '',
    Remark: '',
    // TourDays: 0,
    // TourNights: 0,
    // NormGroupImgNo: "",
    // NormGroupImg: "",
    // NormGroupImgM: "",
    TDHDesc: '',
    FeatureSrc: '',
    DailyList: [],
    EachTripList: [],
    OptionalInfoList: [],
    NoteList: [],
    LeaveTeamReg: '',
    SafeReg: '',
    ActiveNote: '',
    lightBoxVisible: false,
    // siteInfo: {
    DayID: 0,
    POIID: '',
    Name: '',
    ImgList: '',
    ImgMList: '',
    Introduction: '',
    Longtitude: 0,
    Latitude: 0,
    Address: '',
    PhoneList: [],
    WebUrl: '',
    Grade: [],
    CheckIn: '',
    CheckOut: '',
    AntiepReg: '',
    ItinnotesReg: '',
    // },
    // siteInfo: {
    //     DayID: 3,
    //     POIID: '1',
    //     Name: '遠眺琵琶湖・坂本索道纜車',
    //     ImgList:
    //         'https://static.liontech.com.tw/cmspic/PIC1608-007650/M_PIC1608-007650.jpg,https://static.liontech.com.tw/cmspic/PIC2008-010997/M_PIC2008-010997.jpg',
    //     Introduction:
    //         '延曆寺本堂正進行為期十年的大整修，本堂及迴廊屋頂置換、全體塗裝補強等工程，施工期間仍可參拜，寺方特別搭建舞台，使參拜者可以近距離參觀非常罕見的國寶修繕作業，值得一見',
    //     Longtitude: '139.694945',
    //     Latitude: '35.671736',
    //     Address: '台灣台北市114內湖區石潭路151號',
    //     PhoneList: ['86-24-3161-9999', '86-24-3161-9999'],
    //     WebUrl: 'http://www.liontravel.com',
    //     Grade: ['米其林3星'],
    //     CheckIn: '14：00 搭配其他產品或專案銷售時，須依照該產品或專案之規定',
    //     CheckOut: '12：00 搭配其他產品或專案銷售時，須依照該產品或專案之規定',
    // },
};

const itinerariesReducer = (state: I_Itineraries = initialState, action: any): I_Itineraries => {
    const newState = { ...state };

    switch (action.type) {
        case actionTypes.SET_ITINERARIES_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_OPTIONALINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_NOTICEINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_POI_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.TOGGLE_LIGHT_BOX:
            newState.lightBoxVisible = !newState.lightBoxVisible;

            return newState;
        // case actionTypes.CHANGE_SITE_INFO:
        //     newState.siteInfo = action.data;
        //     return newState;
        default:
            return newState;
    }
};

export default itinerariesReducer;
